var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jepisApi } from "../base";
import { removeCepMask, removeCpfMask, removeDateMask, removePhoneMask, } from "../../utils/format";
export var getSchoolsByCity = function (city) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, jepisApi.get("/schools/city/".concat(city))];
            case 1:
                response = _a.sent();
                return [2 /*return*/, response.data];
        }
    });
}); };
function buildCollectiveModalityPayload(payload) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x;
    var data = new FormData();
    var inscricaoData = {
        instituicao_ensino: {
            municipio: (_a = payload.educationalInstitutionData) === null || _a === void 0 ? void 0 : _a.municipio,
            nome_fantasia: (_b = payload.educationalInstitutionData) === null || _b === void 0 ? void 0 : _b.nome_fantasia,
            razao_social: (_c = payload.educationalInstitutionData) === null || _c === void 0 ? void 0 : _c.razao_social,
            inep: (_d = payload.educationalInstitutionData) === null || _d === void 0 ? void 0 : _d.inep,
            email: (_e = payload.educationalInstitutionData) === null || _e === void 0 ? void 0 : _e.email,
            telefone: (_f = payload.educationalInstitutionData) === null || _f === void 0 ? void 0 : _f.telefone,
            endereco: {
                cep: (_g = payload.addressData) === null || _g === void 0 ? void 0 : _g.cep,
                uf: (_h = payload.addressData) === null || _h === void 0 ? void 0 : _h.uf,
                cidade: (_j = payload.addressData) === null || _j === void 0 ? void 0 : _j.municipio,
                bairro: (_k = payload.addressData) === null || _k === void 0 ? void 0 : _k.bairro,
                rua: (_l = payload.addressData) === null || _l === void 0 ? void 0 : _l.logradouro,
                numero: (_m = payload.addressData) === null || _m === void 0 ? void 0 : _m.numero,
                complemento: (_o = payload.addressData) === null || _o === void 0 ? void 0 : _o.complemento,
            },
        },
        modalidade_coletiva: {
            nome: (_p = payload.modality) === null || _p === void 0 ? void 0 : _p.split("|")[2].trim(),
            genero: (_q = payload.modality) === null || _q === void 0 ? void 0 : _q.split("|")[0].trim(),
            categoria: (_r = payload.modality) === null || _r === void 0 ? void 0 : _r.split("|")[1].trim(),
        },
        comissao_tecnica: (_s = payload.technicalCommitteeTechnicalData.comissao_tecnica) === null || _s === void 0 ? void 0 : _s.map(function (data) { return ({
            funcao: data.funcao,
            nome: data.nome,
            cpf: removeCpfMask(data.cpf),
            rg: data.rg,
            cref: data.cref,
        }); }),
        alunos_atletas: (_t = payload.athleteDataForm) === null || _t === void 0 ? void 0 : _t.alunos_atletas.map(function (data) { return ({
            nome: data.nome,
            cpf: removeCpfMask(data.cpf),
            rg: data.rg,
            data_nascimento: removeDateMask(data.data_nascimento),
        }); }),
        aceite_termos: (_u = payload.termsAndConditionsData) === null || _u === void 0 ? void 0 : _u.termo_aceito,
    };
    data.append("inscricao_data", JSON.stringify(inscricaoData));
    if (payload.technicalCommitteeTechnicalData.comissao_tecnica) {
        payload.technicalCommitteeTechnicalData.comissao_tecnica.forEach(function (payload) {
            if (payload.foto_arquivo && payload.cpf) {
                data.append("foto_tecnico_".concat(removeCepMask(payload.cpf)), payload.foto_arquivo[0]);
            }
        });
    }
    if ((_v = payload.athleteDataForm) === null || _v === void 0 ? void 0 : _v.alunos_atletas) {
        (_w = payload.athleteDataForm) === null || _w === void 0 ? void 0 : _w.alunos_atletas.forEach(function (payload) {
            data.append("foto_atleta_".concat(removeCepMask(payload.cpf)), payload.foto_arquivo[0]);
        });
    }
    if (payload.termsAndConditionsData) {
        data.append("termo_responsabilidade_".concat((_x = payload.educationalInstitutionData) === null || _x === void 0 ? void 0 : _x.inep), payload.termsAndConditionsData.termo_arquivo[0]);
    }
    return data;
}
function buildIndividualModalityPayload(payload) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w;
    var data = new FormData();
    var inscricaoData = {
        email: payload.email,
        instituicao: {
            nome: (_a = payload.educationalInstitutionData) === null || _a === void 0 ? void 0 : _a.nome,
            municipio: (_b = payload.educationalInstitutionData) === null || _b === void 0 ? void 0 : _b.municipio,
            razao_social: (_c = payload.educationalInstitutionData) === null || _c === void 0 ? void 0 : _c.razao_social,
            inep: (_d = payload.educationalInstitutionData) === null || _d === void 0 ? void 0 : _d.inep,
            nome_fantasia: (_e = payload.educationalInstitutionData) === null || _e === void 0 ? void 0 : _e.nome_fantasia,
            email: (_f = payload.educationalInstitutionData) === null || _f === void 0 ? void 0 : _f.email,
            telefone: (_g = payload.educationalInstitutionData) === null || _g === void 0 ? void 0 : _g.telefone,
        },
        endereco: {
            cep: (_h = payload.addressData) === null || _h === void 0 ? void 0 : _h.cep,
            uf: (_j = payload.addressData) === null || _j === void 0 ? void 0 : _j.uf,
            municipio: (_k = payload.addressData) === null || _k === void 0 ? void 0 : _k.municipio,
            bairro: (_l = payload.addressData) === null || _l === void 0 ? void 0 : _l.bairro,
            logradouro: (_m = payload.addressData) === null || _m === void 0 ? void 0 : _m.logradouro,
            numero: (_o = payload.addressData) === null || _o === void 0 ? void 0 : _o.numero,
            complemento: (_p = payload.addressData) === null || _p === void 0 ? void 0 : _p.complemento,
        },
        representante: {
            nome: (_q = payload.representativeOfInstitutionData) === null || _q === void 0 ? void 0 : _q.nome,
            cpf: removeCpfMask((_r = payload.representativeOfInstitutionData) === null || _r === void 0 ? void 0 : _r.cpf),
            rg: (_s = payload.representativeOfInstitutionData) === null || _s === void 0 ? void 0 : _s.rg,
            funcao: (_t = payload.representativeOfInstitutionData) === null || _t === void 0 ? void 0 : _t.funcao,
            telefone: (_u = payload.representativeOfInstitutionData) === null || _u === void 0 ? void 0 : _u.telefone,
            email: (_v = payload.representativeOfInstitutionData) === null || _v === void 0 ? void 0 : _v.email,
        },
        modalidades: (_w = payload.modalitiesRegisteredData) === null || _w === void 0 ? void 0 : _w.modalidades,
    };
    data.append("inscricao_data", JSON.stringify(inscricaoData));
    if (payload.representativeOfInstitutionData) {
        data.append("rg_arquivo_representante", payload.representativeOfInstitutionData.rg_arquivo_representante[0]);
    }
    if (payload.representativeOfInstitutionData) {
        data.append("termo_arquivo", payload.representativeOfInstitutionData.termo_arquivo[0]);
    }
    return data;
}
export function createAIndividualModality(payload) {
    return __awaiter(this, void 0, void 0, function () {
        var body, result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    body = buildIndividualModalityPayload(payload);
                    return [4 /*yield*/, jepisApi.post("/registrations/school/individual", body)];
                case 1:
                    result = _a.sent();
                    return [2 /*return*/, result.data];
            }
        });
    });
}
export function createACollectiveModality(payload) {
    return __awaiter(this, void 0, void 0, function () {
        var body, result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    body = buildCollectiveModalityPayload(payload);
                    return [4 /*yield*/, jepisApi.post("/registrations/school/team", body)];
                case 1:
                    result = _a.sent();
                    return [2 /*return*/, result.data];
            }
        });
    });
}
function buildAthleteRegisterData(payload) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2;
    var data = new FormData();
    var inscricaoData = {
        nome_completo: (_a = payload.personalData) === null || _a === void 0 ? void 0 : _a.nome_completo,
        cpf: removeCpfMask((_b = payload.personalData) === null || _b === void 0 ? void 0 : _b.cpf),
        rg: (_c = payload.personalData) === null || _c === void 0 ? void 0 : _c.rg,
        data_nascimento: removeDateMask((_d = payload.personalData) === null || _d === void 0 ? void 0 : _d.data_nascimento),
        sexo: (_e = payload.personalData) === null || _e === void 0 ? void 0 : _e.sexo,
        genero: (_f = payload.categoryAndModalityData) === null || _f === void 0 ? void 0 : _f.genero_modalidade,
        email_contato: (_g = payload.personalData) === null || _g === void 0 ? void 0 : _g.email_contato,
        telefone_contato: removePhoneMask((_h = payload.personalData) === null || _h === void 0 ? void 0 : _h.telefone_contato),
        endereco: {
            cep: removeCepMask((_j = payload.addressData) === null || _j === void 0 ? void 0 : _j.cep),
            uf: (_k = payload.addressData) === null || _k === void 0 ? void 0 : _k.uf,
            municipio: (_l = payload.addressData) === null || _l === void 0 ? void 0 : _l.municipio,
            logradouro: (_m = payload.addressData) === null || _m === void 0 ? void 0 : _m.logradouro,
            bairro: (_o = payload.addressData) === null || _o === void 0 ? void 0 : _o.bairro,
            numero: (_p = payload.addressData) === null || _p === void 0 ? void 0 : _p.numero,
            complemento: (_q = payload.addressData) === null || _q === void 0 ? void 0 : _q.complemento,
        },
        inep_estudante: (_r = payload.schoolData) === null || _r === void 0 ? void 0 : _r.inep_aluno,
        registro_confederacao: (_s = payload.schoolData) === null || _s === void 0 ? void 0 : _s.registro_confederacao,
        escola: { id: (_t = payload.schoolData) === null || _t === void 0 ? void 0 : _t.escola.id },
        modalidades: (_u = payload.categoryAndModalityData) === null || _u === void 0 ? void 0 : _u.modalidades,
        categoria: (_v = payload.categoryAndModalityData) === null || _v === void 0 ? void 0 : _v.categoria,
        responsavel_legal: {
            nome_completo: (_w = payload.legalRepresentativeData) === null || _w === void 0 ? void 0 : _w.nome_completo,
            cpf: removeCpfMask((_x = payload.legalRepresentativeData) === null || _x === void 0 ? void 0 : _x.cpf),
            rg: (_y = payload.legalRepresentativeData) === null || _y === void 0 ? void 0 : _y.rg,
            grau_parentesco: (_z = payload.legalRepresentativeData) === null || _z === void 0 ? void 0 : _z.grau_parentesco,
            email: (_0 = payload.legalRepresentativeData) === null || _0 === void 0 ? void 0 : _0.email_contato,
            telefone: removePhoneMask((_1 = payload.legalRepresentativeData) === null || _1 === void 0 ? void 0 : _1.telefone_contato),
        },
        termo_aceito: (_2 = payload.termsAndConditionsData) === null || _2 === void 0 ? void 0 : _2.termo_aceito,
    };
    data.append("inscricao_data", JSON.stringify(inscricaoData));
    if (payload.legalRepresentativeData)
        data.append("termo_arquivo", payload.legalRepresentativeData.termo_arquivo[0]);
    if (payload.personalData)
        data.append("rg_arquivo_estudante", payload.personalData.rg_arquivo_estudante[0]);
    if (payload.legalRepresentativeData)
        data.append("rg_arquivo_responsavel", payload.legalRepresentativeData.rg_arquivo_responsavel[0]);
    return data;
}
export function createAthleteRegister(payload) {
    return __awaiter(this, void 0, void 0, function () {
        var body, result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    body = buildAthleteRegisterData(payload);
                    return [4 /*yield*/, jepisApi.post("/registrations/student-athlete", body)];
                case 1:
                    result = _a.sent();
                    return [2 /*return*/, result.data];
            }
        });
    });
}
function buildTechnicalRegisterData(payload) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
    var formData = new FormData();
    if (!payload.personalData) {
        return;
    }
    var inscricaoData = {
        nome_completo: payload.personalData.nome_completo,
        cpf: removeCpfMask(payload.personalData.cpf),
        rg: payload.personalData.rg,
        data_nascimento: removeDateMask((_a = payload.personalData) === null || _a === void 0 ? void 0 : _a.data_nascimento),
        sexo: payload.personalData.sexo,
        email_contato: payload.personalData.email_contato,
        telefone_contato: removePhoneMask((_b = payload.personalData) === null || _b === void 0 ? void 0 : _b.telefone_contato),
        endereco: {
            cep: removeCepMask((_c = payload.addressData) === null || _c === void 0 ? void 0 : _c.cep),
            uf: (_d = payload.addressData) === null || _d === void 0 ? void 0 : _d.uf,
            municipio: (_e = payload.addressData) === null || _e === void 0 ? void 0 : _e.municipio,
            logradouro: (_f = payload.addressData) === null || _f === void 0 ? void 0 : _f.logradouro,
            bairro: (_g = payload.addressData) === null || _g === void 0 ? void 0 : _g.bairro,
            complemento: (_h = payload.addressData) === null || _h === void 0 ? void 0 : _h.complemento,
            numero: (_j = payload.addressData) === null || _j === void 0 ? void 0 : _j.numero,
        },
        categoria: (_k = payload.schoolData) === null || _k === void 0 ? void 0 : _k.categoria,
        modalidade: (_l = payload.schoolData) === null || _l === void 0 ? void 0 : _l.modalidade,
        funcao: (_m = payload.professionalData) === null || _m === void 0 ? void 0 : _m.funcao,
        cref: (_o = payload.professionalData) === null || _o === void 0 ? void 0 : _o.cref,
        genero: (_p = payload.schoolData) === null || _p === void 0 ? void 0 : _p.genero_modalidade,
        escola: {
            id: (_r = (_q = payload.schoolData) === null || _q === void 0 ? void 0 : _q.escola) === null || _r === void 0 ? void 0 : _r.id,
        },
    };
    formData.append("inscricao_data", JSON.stringify(inscricaoData));
    if (payload.professionalData)
        formData.append("termo_arquivo", (_s = payload.professionalData) === null || _s === void 0 ? void 0 : _s.termo_arquivo[0]);
    if (payload.professionalData)
        formData.append("cref_arquivo", (_t = payload.professionalData) === null || _t === void 0 ? void 0 : _t.cref_arquivo[0]);
    return formData;
}
export function createTechnicalRegister(payload) {
    return __awaiter(this, void 0, void 0, function () {
        var body, result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    body = buildTechnicalRegisterData(payload);
                    return [4 /*yield*/, jepisApi.post("/registrations/coach", body)];
                case 1:
                    result = _a.sent();
                    return [2 /*return*/, result.data];
            }
        });
    });
}
export function searchRegistration(payload) {
    return __awaiter(this, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, jepisApi.get("/registrations/search", {
                        params: payload,
                    })];
                case 1:
                    response = _a.sent();
                    return [2 /*return*/, response.data];
            }
        });
    });
}
